class TreeMenu {
    constructor(domElement, options) {
        this.domElement = domElement;
        this.storageKey = options.storageKey || null;

        this.treeRowDragEvent = null;
        this.treeRowMouseUpEvent = null;

        this.draggingElement = null;
        this.dragOverElement = null;

        this.bindEvents();

        if (!!this.storageKey) {
            this.restoreState();
        }
    }

    bindEvents() {
        const expanderDomElements = this.domElement.getElementsByClassName('tree-expander');
        for (let i = 0; i < expanderDomElements.length; i++) {
            const expanderDomElement = expanderDomElements[i];
            expanderDomElement.addEventListener('click', this.onExpanderClick.bind(this));
        }

        const treeRowDomElements = this.domElement.getElementsByClassName('tree-row');
        for (let i = 0; i < treeRowDomElements.length; i++) {
            const treeRowDomElement = treeRowDomElements[i];
            treeRowDomElement.addEventListener('mousedown', this.onTreeRowMouseDown.bind(this));
        }
    }

    saveState(id, state) {
        if (!this.storageKey) {
            throw new Error('Unable to save state, no storage key set');
        }

        let states = {};
        try {
            states = JSON.parse(window['localStorage'].getItem(this.storageKey) || '{}');
        } catch (ex) {
        }

        states[id] = state;

        window.localStorage.setItem(this.storageKey, JSON.stringify(states));
    }

    restoreState() {
        if (!this.storageKey) {
            throw new Error('Unable to restore state, no storage key set');
        }

        let states = {};
        try {
            states = JSON.parse(window['localStorage'].getItem(this.storageKey) || '{}');
        } catch (ex) {
        }

        const treeRowDomElements = this.domElement.getElementsByClassName('tree-row');
        for (let i = 0; i < treeRowDomElements.length; i++) {
            const treeRowDomElement = treeRowDomElements[i];
            const treeRowId = treeRowDomElement.dataset['node'] || null;
            if (!treeRowId) {
                continue;
            }

            if (states.hasOwnProperty(treeRowId)) {
                this.toggleNode(treeRowDomElement, states[treeRowId]);
            }
        }
    }

    toggleNode(target, state) {
        if (target.classList.contains('tree-row') === false) {
            return;
        }

        target.classList.toggle('tree-expanded', state);

        if (!!this.storageKey) {
            this.saveState(target.dataset['node'] || null, target.classList.contains('tree-expanded'));
        }
    }

    onExpanderClick(e) {
        e.preventDefault();

        let target = e.target;
        while (target) {
            if (target.classList && target.classList.contains('tree-row')) {
                break;
            }

            target = target.parentNode;
            if (!target || target.isSameNode(document.body)) {
                return;
            }
        }

        this.toggleNode(target, undefined);
    }

    onTreeRowMouseDown(e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        this.treeRowDragEvent = this.onTreeRowDrag.bind(this);
        this.treeRowMouseUpEvent = this.onTreeRowMouseUp.bind(this);
        this.draggingElement = e.target;

        document.addEventListener('mousemove', this.treeRowDragEvent);
        document.addEventListener('mouseup', this.treeRowMouseUpEvent);
    }

    onTreeRowMouseUp(e) {
        if (this.dragOverElement) {
            this.onTreeRowDrop({target: this.dragOverElement});

            this.draggingElement = null;
            this.dragOverElement = null;
        }

        document.removeEventListener('mouseup', this.treeRowMouseUpEvent);
        document.removeEventListener('mousemove', this.treeRowDragEvent);
    }

    onTreeRowDrag(e) {
        const hoverDomElement = document.elementFromPoint(e.clientX, e.clientY);
        if (hoverDomElement.classList.contains('tree-row')) {
            if (!!this.dragOverElement) {
                if (hoverDomElement.isSameNode(this.dragOverElement)) {
                    return;
                }

                this.onTreeDragLeave({target: this.dragOverElement});
            }

            this.dragOverElement = hoverDomElement;
            this.onTreeDragEnter({target: this.dragOverElement});
        }
    }

    onTreeRowDrop(e) {
        e.target.classList.toggle('dragover', false);
    }

    onTreeDragEnter(e) {
        e.target.classList.toggle('dragover', true);
    }

    onTreeDragLeave(e) {
        e.target.classList.toggle('dragover', false);
    }
}

export default TreeMenu;
